<template>
  <div class="location-container loactionMb">
    <img src="../../assets/img/afmLocation.png"/>
    <h2>{{ $t('location_upper') }}</h2>
    <div class="location-content">
      <p>1. Bellevue AFM 14515 NE 20th St, Bellevue WA 98007</p>
      <p>2. Seattle AFM 13200 Aurora Ave N, Seattle WA 98133</p>
      <p>3. Oregon AFC 3849 SW 117th Ave, Beaverton WA 97005</p>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  name: "location",
  data() {
    return {}
  },
  methods: {},
  mounted() {
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
  }),
  watch: {}
}
</script>
<style scoped lang="less">
@import "../../assets/css/profileorder.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/location.vue